var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"col":"","md":"12 text-center"}},[_c('b-img',{attrs:{"src":"/img/empty_state.png","alt":"No Search","height":"400"}}),_c('h5',[_c('p',[_vm._v(_vm._s(_vm.message))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }